/* eslint-disable @typescript-eslint/no-explicit-any */
import {WidgetType} from '@codemirror/view';

export interface ReactWidgetHandlers {
  onMount?: (widget: any) => void;
  onUpdate?: (widget: any) => void;
  onDestroy: (widget: any) => void;
}

export abstract class ReactWidget extends WidgetType {
  private handlers: ReactWidgetHandlers;
  element!: HTMLElement;

  /**
   * Constructor should be as computationally cheap as possible, do not perform any expensive operations.
   * This is because the constructor will be called when when the MatchDecorator finds a match, which can
   * occur after every view update in the editor.
   */
  constructor(handlers: ReactWidgetHandlers) {
    super();
    this.handlers = handlers;
  }

  toDOM(): HTMLElement {
    this.element = document.createElement('span');
    this.element.classList.add('cm-widget-react');
    this.handlers.onMount?.(this);
    return this.element;
  }

  updateDOM(dom: HTMLElement): boolean {
    this.element = dom;
    this.handlers.onUpdate?.(this);
    return true; // Always return true to prevent toDOM from being called again. DOM updates are handled by React.
  }

  ignoreEvent(event: Event): boolean {
    if (
      event.type === 'mousedown' ||
      event.type === 'mouseup' ||
      event.type === 'click'
    ) {
      return true;
    }
    return false;
  }

  destroy() {
    this.element?.remove();
    this.handlers.onDestroy(this);
  }
}
